import React from 'react';

const ConsultationPaymentWebViewScreen = () => {
  return <></>;
};

export default ConsultationPaymentWebViewScreen;
